export enum UserFields {
  userId = "userId",
  name = "name",
  email = "email",
  company = "company",
  relevance = "relevance",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}
